'use strict';

var core = require('core/components/clientSideValidation');

core.onChange = function () {
    $(document).on('change', 'form input.is-invalid, form select.is-invalid, form textarea.is-invalid', function () {
        $(this).removeClass('is-valid').removeClass('is-invalid');
    });
};

/**
 * LEG-615: when the bot check refuses a form, the base form handler puts the refusal message in an alert at the top
 * of the form. Three forms stay on their page after a later try is accepted (gift card apply in checkout, gift card
 * balance, password reset): nothing removed that alert there, and in checkout each further refusal added one more.
 * Each new try on these forms now starts without it.
 */
core.onRetry = function () {
    $('body').on('click', '.giftcertificate-information .js-applybalancebutton', function () {
        $(this).closest('form').children('.alert-danger').remove();
    });
    // A refused gift card leaves its message at the top of the payment form, and the payment step's button sits
    // outside that form: paying by card instead is a new try on it too. The click is read from the button's row, not
    // from the button: the payment step disables its button first, and jQuery then skips it as the clicked element.
    $('body').on('click', '.next-step-button', function (e) {
        if ($(e.target).closest('.submit-payment').length) {
            $('#dwfrm_billing').children('.alert-danger').remove();
        }
    });
    // Capture phase: the password reset form's own submit handler stops the event before it can bubble.
    document.addEventListener('submit', function (e) {
        $(e.target).filter('form.check-balance, form.reset-password-form').children('.alert-danger').remove();
    }, true);
};

module.exports = core;